import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landscape-view-hidden',
  templateUrl: './landscape-view-hidden.component.html',
  styleUrls: ['./landscape-view-hidden.component.less']
})
export class LandscapeViewHiddenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
